import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-address\"><path d=\"M366.763 457.813c0-76.458 66.133-141.653 143.786-141.653s143.83 65.195 143.83 141.653c0 76.502-63.275 141.654-143.787 141.654-80.555 0-143.83-65.152-143.83-141.654zM128 423.851c0 328.576 343.723 561.194 343.723 561.194 19.626 8.491 63.402 8.491 74.922 0 0 0 349.355-238.293 349.355-558.378C893.099 219.86 723.413 52.736 510.55 52.736 297.727 52.736 128 219.861 128 423.851z\" fill=\"#ffffff\" p-id=\"1539\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol